// extracted by mini-css-extract-plugin
export var Link = "markdown-link-module--Link--qPzOA";